import './CandidaciesListRow.scss';

import { Box }               from '@chakra-ui/react';
import CandidacyModel        from '@/models/services/rh/CandidacyModel';
import Image                 from '@/components/Image/Image';
import { Link }              from 'react-router-dom';
import { Tag }               from "@/components/ui/tag"
import { Text }              from '@chakra-ui/react';
import { observer }          from 'mobx-react';
import useScreenSize         from '@/hooks/useScreenSize';
import { useTranslation }    from 'react-i18next';

interface ICandidaciesListRowProps {
	candidacy: CandidacyModel;
}

const CandidacyImage = observer((props: { candidacy: CandidacyModel }) => {
	const { candidacy } = props;

	return <Image errorSize='xl' borderRadius="md" src={candidacy.privateCampaignPictureUrl} />;
});

const CandidaciesListRow = (props: ICandidaciesListRowProps) => {

	const { candidacy } = props;

	const { t } = useTranslation();
	const { isLG } = useScreenSize();

	return (
		<Link to={candidacy.url} target="_blank">
			<Box
				display="flex"
				alignItems="center"
				justifyContent="space-between"
				overflow="auto"
				_hover={{
					cursor: "pointer"
				}}
			>
					<Box
						display="flex"
						alignItems="center"
						gap="20px"
					>
						<Box 
							maxWidth="65px" 
							minWidth="65px" 
							height="65px"
							display="flex"
							flexDirection="column"
							alignItems="center"
							justifyContent="center"
						>
							<CandidacyImage candidacy={candidacy} />
						</Box>
						<Box
							display="flex"
							flexDirection="column"
							gap="5px"
							marginRight="40px"
						>
							<Box><Text className="poppins-semibold" fontSize="16px" textDecoration="underline">{candidacy.title}</Text></Box>
							<Box fontSize="12px">
								<Text>{candidacy.entertainmentTitle}</Text>
							</Box>
							{
								!isLG && 
								<Box>
									<Tag colorPalette={candidacy.color}>{t(`pages.candidacies.statuses.${candidacy.statusReference}`)}</Tag>
								</Box>
							}
						</Box>
					</Box>
					{
						isLG && 
						<Tag colorPalette={candidacy.color}>{t(`pages.candidacies.statuses.${candidacy.statusReference}`)}</Tag>
					}
			</Box>
		</Link>
	)
}

export default CandidaciesListRow;